export default __webpack_public_path__ + "static/media/Galaxy_10.38a86766.png";